import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './lib/theme-context';

// Import service worker manager for PWA functionality
import './lib/serviceWorker';

// Add global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Prevent the default browser behavior for certain types of errors
  if (event.reason?.message?.includes('message port closed') || 
      event.reason?.message?.includes('ERR_NAME_NOT_RESOLVED')) {
    event.preventDefault();
  }
});

// Add global error handler for runtime errors
window.addEventListener('error', (event) => {
  console.error('Runtime error:', event.error);
  
  // Prevent the default browser behavior for service worker related errors
  if (event.error?.message?.includes('message port closed') ||
      event.error?.stack?.includes('service-worker')) {
    event.preventDefault();
  }
});

createRoot(document.getElementById('root')!).render(
  // Temporarily disabled React StrictMode to reduce duplicate console logs in development
  // StrictMode intentionally double-invokes effects and functions to detect side effects
  // Re-enable for production builds to catch potential issues
  // <StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ThemeProvider>
        <App />
        <Toaster />
      </ThemeProvider>
    </BrowserRouter>
  // </StrictMode>
);